// extracted by mini-css-extract-plugin
export default {"previewImage":"UploadImage_previewImage__6hPUd"};